import {ReactElement, useEffect} from 'react'
import {useLocation} from 'react-router'
import {pendoTrackLegacyRedirect} from '../../app-router'

type WithRedirectLoggingProps = {
  children: ReactElement
  routeName: string
}

export function WithRedirectLogging(props: WithRedirectLoggingProps) {
  const {children, routeName} = props
  const location = useLocation()

  useEffect(() => {
    pendoTrackLegacyRedirect({
      key: 'LegacyRedirect',
      eventData: {
        from: location.pathname,
        route: routeName,
        referrer: document.referrer || null,
      },
    })
  }, [location.pathname, routeName])

  return children
}
